import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { loadConfig } from './app/lib/config';
import { configureAuth } from './app/lib/auth';
import { createApolloClient } from './app/lib/apollo';
import { App } from './app/App';
import './styles/index.css';

async function bootstrap() {
  const cfg = await loadConfig();
  configureAuth(cfg);
  const client = createApolloClient(cfg);
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ApolloProvider client={client}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ApolloProvider>
    </React.StrictMode>,
  );
}

bootstrap();
